import React, { useState } from "react";
import { aboutData } from "../AboutMe/AboutData.js";
import "./About.css";

function Carousel({ images }) {
  const [activeIdx, setActiveIdx] = useState(0);
  return (
    <div className="carousel">
      <img
        src={images[activeIdx]}
        alt={`slide-${activeIdx}`}
        className="carousel-img"
      />
      <div className="carousel-controls">
        {images.map((_, idx) => (
          <button
            key={idx}
            className={`carousel-dot${activeIdx === idx ? " active" : ""}`}
            onClick={() => setActiveIdx(idx)}
          />
        ))}
      </div>
    </div>
  );
}

export default function About() {
  return (
    <div className="about-container">
      <h1 className="about-heading">{aboutData.heading}</h1>
      {aboutData.sections.map((section, idx) => (
        <div key={idx} className="section-block">
          <h2 className="section-title">{section.title}</h2>
          {section.imageUrls &&
            section.imageUrls.length > 0 &&
            (section.imageUrls.length === 1 ? (
              <img
                src={section.imageUrls[0]}
                alt={section.title}
                className="section-img"
              />
            ) : (
              <Carousel images={section.imageUrls} />
            ))}
          {section.details && (
            <p className="section-details">{section.details}</p>
          )}
          {section.papers && (
            <div className="papers-list">
              {section.papers.map((paper, i) => (
                <div key={i} className="paper-card">
                  <h3 className="paper-title">{paper.title}</h3>
                  <p className="paper-abstract">{paper.abstract}</p>
                  <object
                    data={paper.pdf}
                    type="application/pdf"
                    width="100%"
                    height="400px"
                    className="pdf-view"
                    aria-label="PDF preview"
                  >
                    <div style={{ textAlign: "center", padding: "20px" }}>
                      <p>PDF preview is not available.</p>
                      <a
                        href={paper.pdf}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="read-full-link"
                        style={{
                          display: "inline-block",
                          padding: "8px 16px",
                          background: "#3a72e2",
                          color: "#fff",
                          borderRadius: "5px",
                          textDecoration: "none",
                          fontWeight: "600",
                        }}
                      >
                        Read Full Text
                      </a>
                    </div>
                  </object>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
